import { render, staticRenderFns } from "./shopify_orders_page.vue?vue&type=template&id=baa1241c&"
import script from "./shopify_orders_page.vue?vue&type=script&lang=js&"
export * from "./shopify_orders_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports